import { Box, Typography } from "@mui/material";

export type DatasetItem = {
  product: string;
  facilities: number;
  clients: number;
  icon?: string;
};

export type TooltipContentProps = {
  item: DatasetItem;
  type: "facilities" | "clients" | "icons";
};

export const TooltipContent = ({ item, type }: TooltipContentProps) => {
  const isIcon = type === "icons";

  return (
    <Box
      sx={{
        p: isIcon ? "10px 14px" : 2,
        minWidth: isIcon ? "auto" : 200,
        textAlign: isIcon ? "center" : "left",
        background: "linear-gradient(180deg, #0f172a 0%, #020617 100%)",
        borderRadius: 2,
        color: "#fff",
        boxShadow: "0px 14px 40px rgba(0,0,0,0.55)",
      }}
    >
      {isIcon ? (
        <Typography fontWeight={700} fontSize={14}>
          {item.product}
        </Typography>
      ) : (
        <>
          <Typography fontWeight={700} mb={0.5}>
            {item.product}
          </Typography>

          <Typography
            variant="body2"
            fontWeight={600}
            color={
              type === "facilities" ? "rgba(19,131,213)" : "rgba(18,211,255)"
            }
          >
            <Box component="span">
              {type === "facilities" ? item.facilities : item.clients}
            </Box>{" "}
            {type === "facilities"
              ? "facilities subscribed"
              : "clients subscribed"}
          </Typography>
        </>
      )}
    </Box>
  );
};
